var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3"},[_c('div',{staticClass:"text-center nb-footer"},[_c('div',[_c('div',{staticClass:"body-4"},[_vm._v(_vm._s(_vm.$t("components.footer.needHelp"))+"?")]),(_vm.text)?_c('a',{staticClass:"body-4 ml-3 mb-0",class:_vm.link ? 'link-1' : '',attrs:{"href":_vm.link ? _vm.link : '#'}},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }